module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("A DAVID & CHARLES BOOK"), _c('br'), _vm._v("Copyright © David & Charles Limited 2009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("David & Charles is an F+W Media Inc. company"), _c('br'), _vm._v("4700 East Galbraith Road"), _c('br'), _vm._v("Cincinnati, OH 45236")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First published in the UK and US in 2009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Text and designs copyright © Pam Lintott and Nicky Lintott 2009"), _c('br'), _vm._v("Layout and photography copyright © David & Charles 2009")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Pam Lintott and Nicky Lintott have asserted their right to be identified as authors of this work in accordance with the Copyright, Designs and Patents Act, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic or mechanical, by photocopying, recording or otherwise, without prior permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The designs in this book are copyright and must not be stitched/made for resale.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The author and publisher have made every effort to ensure that all the instructions in the book are accurate and safe, and therefore cannot accept liability for any resulting injury, damage or loss to persons or property, however it may arise.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Names of manufacturers, fabric ranges and other products are provided for the information of readers, with no intention to infringe copyright or trademarks."), _c('br'), _vm._v("‘Jelly Roll’ is a trademark of Moda Fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-10: 978-0-7153-3311-2 paperback"), _c('br'), _vm._v("ISBN-13: 0-7153-3311-9 paperback")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in China by RR Donnelley"), _c('br'), _vm._v("for David & Charles"), _c('br'), _vm._v("Brunel House Newton Abbot Devon")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Commissioning Editor Jane Trollope"), _c('br'), _vm._v("Editorial Manager Emily Pitcher"), _c('br'), _vm._v("Assistant Editor Kate Nicholson"), _c('br'), _vm._v("Project Editor Lin Clements"), _c('br'), _vm._v("Art Editor Sarah Clark"), _c('br'), _vm._v("Designer Sarah Underhill"), _c('br'), _vm._v("Production Controller Kelly Smith"), _c('br'), _vm._v("Photographers Sian Irvine and Karl Adamson")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Visit our website at "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.davidandcharles.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.davidandcharles.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("David & Charles books are available from all good bookshops; alternatively you can contact our Orderline on 0870 9908222 or write to us at FREEPOST EX2 110, D&C Direct, Newton Abbot, TQ12 4ZZ (no stamp required UK only); US customers call 800-289-0963 and Canadian customers call 800-840-5220.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94bd8aa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446350935_epub_cop_r1.vue
// module id = 60
// module chunks = 0